module.exports = __webpack_public_path__ + "img/ICO_m_premium.ec60a8cf.svg";